<div class="add-container">
    <h1 class="add-title">Adaugă document public</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">

        <div class="row">
            <div class="col-md-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>An</mat-label>
                    <mat-select formControlName="id_document_year">
                        <mat-option *ngFor="let an of aniList" [value]="an.id">
                            {{ an.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['id_document_year'].valid && form.controls['id_document_year'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Direcție</mat-label>
                    <mat-select formControlName="id_directie" (selectionChange)="onDirectieChange($event.value)">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let directie of directiiActive" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_directie'].valid && form.controls['id_directie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="id_compartiment"
                        (selectionChange)="onDirectieCompartimentChange($event.value)">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let compartiment of compartimenteActive$ | async" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['id_compartiment'].valid && form.controls['id_compartiment'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Operator</mat-label>
                    <input type="text" matInput formControlName="name" [matAutocomplete]="auto" />
                    <mat-icon matSuffix class="opacity-50">search</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngIf="usersActive$.length == 0">No results found</mat-option>
                        <mat-option *ngFor="let user of filteredActiveUsers" [value]="user.name"
                            (onSelectionChange)="onActiveUsersChange(user)">
                            {{ user.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="this.form.get('id_directie')?.value !== '-1' && usersActive$.length == 0 && !isLoading"
            class="d-flex justify-content-start mb-3">
            <ng-container *ngIf="!isAddMode">
                <button type="button" class="btn btn-sm btn-primary" (click)="onAddMode()">
                    <i class="fa-solid fa-plus"></i>
                    Adaugă operator
                </button>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <button type="button" class="btn btn-sm btn-danger" (click)="onAddMode()">
                    <i class="fa-solid fa-xmark"></i>
                    Anulează
                </button>
            </ng-container>
        </div>

        <ng-container *ngIf="isAddMode">
            <form [formGroup]="formOperator">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Nume</mat-label>
                            <input type="text" matInput formControlName="name" />
                            <mat-error
                                *ngIf="!formOperator.controls['name'].valid && formOperator.controls['name'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Tip Operator</mat-label>
                            <mat-select formControlName="type">
                                <mat-option *ngFor="let type of userTypes" [value]="type.id">
                                    {{ type.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="!formOperator.controls['type'].valid && formOperator.controls['type'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Direcție</mat-label>
                            <mat-select formControlName="id_directie"
                                (selectionChange)="onDirectieOperatorChange($event.value)">
                                <mat-option value="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let directie of directiiActive" [value]="directie.id">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="!formOperator.controls['id_directie'].valid && formOperator.controls['id_directie'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Compartiment</mat-label>
                            <mat-select formControlName="id_compartiment">
                                <mat-option value="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let compartiment of compartimenteActiveOperator$ | async"
                                    [value]="compartiment.id">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col d-flex justify-content-end">
                        <button class="buttons" type="button" mat-flat-button color="primary"
                            [disabled]="formOperator.invalid" (click)="submitFormOperator()">
                            {{ helper.dialogConfig.buttonLabels.save }}
                        </button>
                    </div>
                </div>
            </form>
            <mat-divider class="my-3"></mat-divider>
        </ng-container>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Document</mat-label>
                    <mat-select formControlName="id_document_type">
                        <mat-option *ngFor="let tipDocument of tipuriDocumente" [value]="tipDocument.id">
                            {{ tipDocument.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['id_document_type'].valid && form.controls['id_document_type'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-card-subtitle>Arhivare:</mat-card-subtitle>
                <mat-radio-group (change)="onArhivareChange($event)" class="d-flex flex-md-row flex-column gap-3"
                    formControlName="archive_to">
                    <mat-radio-button [value]=true color="primary">Da</mat-radio-button>
                    <mat-radio-button [value]=false color="primary">Nu</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <div *ngIf="this.form.get('archive_to')?.value === true" class="row mt-2">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Data arhivării</mat-label>
                    <input matInput [matDatepicker]="arhivarePicker" formControlName="archive_date" readonly
                        (focus)="arhivarePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="arhivarePicker"></mat-datepicker-toggle>
                    <mat-datepicker #arhivarePicker></mat-datepicker>
                    <mat-error *ngIf="!form.controls['archive_date'].valid && form.controls['archive_date'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col">
                <mat-card-subtitle>Activ:</mat-card-subtitle>
                <mat-radio-group class="d-flex flex-md-row flex-column gap-3" formControlName="active">
                    <mat-radio-button [value]=true color="primary">Da</mat-radio-button>
                    <mat-radio-button [value]=false color="primary">Nu</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <ng-container *ngIf="this.form.get('active')?.value === true">
            <div class="row mt-2">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Dată început</mat-label>
                        <input matInput [matDatepicker]="dateFromPicker" formControlName="active_from" readonly
                            (focus)="dateFromPicker.open()" />
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dateFromPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Oră început</mat-label>
                        <input [ngxMatTimepicker]="fromTimepicker" matInput formControlName="ora_from" [format]="24"
                            readonly />
                        <ngx-mat-timepicker color="primary" #fromTimepicker></ngx-mat-timepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Dată sfârșit</mat-label>
                        <input matInput [matDatepicker]="dateEndPicker" formControlName="active_end" readonly
                            (focus)="dateEndPicker.open()" />
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dateEndPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dateEndPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Oră sfârșit</mat-label>
                        <input [ngxMatTimepicker]="endTimepicker" matInput formControlName="ora_end" [format]="24"
                            readonly />
                        <ngx-mat-timepicker color="primary" #endTimepicker></ngx-mat-timepicker>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <div class="container__upload d-flex flex-column my-4">
            <div class="container__upload-header d-flex flex-row justify-content-between align-items-center">
                <p class="m-0">Fotografii/Documente</p>
                <button type="button" class="upload-btn" (click)="fileInput.click()">
                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="container__upload-files" *ngIf="form.value.files.length > 0 && !uploading.documente_fotografii">
                <div class="container__upload-file d-flex flex-row justify-content-between align-items-center"
                    *ngFor="let uploadedFile of form.value.files; let i = index">
                    <span class="container__upload-file-name">
                        {{ (uploadedFile.original_name.length > 30) ? (uploadedFile.original_name | slice: 0:30) +
                        '..' : (uploadedFile.original_name) }}
                    </span>

                    <div>
                        <button class="container__upload-file-delete d-flex" type="button"
                            matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                *ngIf="uploading.documente_fotografii"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event, 'documente_fotografii')"
                multiple style="display: none">
        </div>
        <div class="row mb-3">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații</mat-label>
                    <input type="text" matInput formControlName="observations" />
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>